import FormPropertyFacility from './FormPropertyFacility';

export default FormPropertyFacility;
